import { getProp } from "../ParsedSummary";

export const nextSteps = (summary, sections) => {
  const nextSteps = getProp(summary, ['next', 'step', 'recommend']);
  if (nextSteps) {
    const title = getProp(nextSteps, 'title');
    sections.push({
      type: 'title-main',
      content: title || 'Recommended Next Steps'
    });

    const mathLearning = getProp(nextSteps, ['math', 'learning']);
    if (mathLearning) {
      const label = getProp(mathLearning, 'label');
      sections.push({
        type: 'subtitle',
        content: label || 'Math Learning'
      });

      const recommendations = getProp(mathLearning, 'recommendation');
      if (recommendations && Array.isArray(recommendations) && recommendations.length > 0) {
        recommendations.forEach(rec => {
          const recText = typeof rec === 'string' ? rec : getProp(rec, 'recommendation');
          if (recText && typeof recText === 'string') {
            sections.push({
              type: 'ordered-list',
              content: recText
            });
          }
        });
      }
    }

    const collaboration = getProp(nextSteps, ['collaboration', 'discourse']);
    if (collaboration) {
      sections.push({
        type: 'subtitle',
        content: 'Collaboration'
      });

      const collabRecommendations = getProp(collaboration, 'recommendation');
      if (collabRecommendations && Array.isArray(collabRecommendations) && collabRecommendations.length > 0) {
        collabRecommendations.forEach(rec => {
          const recText = typeof rec === 'string' ? rec : getProp(rec, 'recommendation');
          if (recText && typeof recText === 'string') {
            sections.push({
              type: 'ordered-list',
              content: recText
            });
          }
        });
      }
    }
  }
}
